import { updateTour } from "../../data/repository/tourRepo";

export const updateTourUseCase = async (tour) => {
  const response = await updateTour(tour);
  return response;
};
